import {sspTypeValues} from 'common/api/dictionaries.tsx'
import {DictionarySelector, DictionarySelectorProps} from 'common/components/dictionary/DictionarySelector.tsx'
import {FC} from 'react'

export const SspTypeSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="sspType"
                        loader={() => Promise.resolve(sspTypeValues)}
    />